<template>
  <div class="homepage-top">
    <!-- <img v-if="content == '首页'" class="returnHomepage pointer" @click="toHomePage" src="../../../assets/returnHomepage.png" /> -->
    <img v-if="projectName == '医药云课堂PC'" class="logo" src="@/assets/guidePage/logo.png" mode="scaleToFill" />
    <img v-if="projectName == '云课堂'" class="homepage-logo1" src="../../../assets/test/logo.png" />
    <img v-if="projectName == '新陆'" class="homepage-logo2" src="@/assets/register/xinlu/logoRight.png" />
    <div class="flex align">
      <div class="userBox" @click="personalInformation">
        <img class="headPortrait" src="../../../assets/head.png" />
        <div class="userName">{{ userName }} ></div>
      </div>
      <div v-if="content == '首页'" class="returnHomepage pointer" @click="toHomePage">返回首页 ></div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      userName: "",
      projectName: "",
    };
  },
  props: {
    content: {
      // 定义接收的类型 还可以定义多种类型 [String, Undefined, Number]
      // 如果required为true,尽量type允许undefined类型，因为传递过来的参数是异步的。或者设置默认值。
      type: String,
      // 定义是否必须传
      required: false,
      // 定义默认值
      default: "暂无",
    },
  },
  created() {
    this.userName = this.$store.state.loginRecord.data?.datas.name;
    this.projectName = this.$store.state.projectName;
  },
  methods: {
    personalInformation() {
      this.$router.push("/personalInformation");
    },
    // 进入home页面
    toHomePage() {
      this.$router.push("/guidePage");
    },
  },
};
</script>

<style lang="scss" scoped>
/* header */
.homepage-top {
  position: fixed;
  width: 100%;
  height: 70px;
  background-image: url(@/assets/guidePage/topBg.png);
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 10px;
  box-sizing: border-box;
  z-index: 100;
}

.homepage-logo {
  width: 183px;
  height: 30px;
}

.logo {
  width: 234px;
  height: 49px;
}

.homepage-logo1 {
  width: 80px;
  height: 60px;
}

.homepage-logo2 {
  width: 301px;
  height: 50px;
}

.userBox {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.headPortrait {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  object-fit: cover;
}

.userName {
  // 
  font-size: 18px;
  color: #ffffff;
  line-height: 18px;
  margin-left: 14px;
  font-weight: bold;
}

.userBox-icon {
  width: 10px;
  height: 18px;
  margin-left: 12px;
}

.returnHomepage {
  margin-right: 20px;
  font-size: 18px;
  color: #ffffff;
  line-height: 18px;
  margin-left: 14px;
  font-weight: bold;
}
</style>
